import React from 'react';
import ApplicationsHistoryTable from './ApplicationsHistoryTable';
import ApplicationDetailsCard from './ApplicationDetailsCard';
import ApplicationDetailsEditCard from './ApplicationDetailsEditCard';
import { ApplicationStatuses, RecipientTypes } from '../../../lib/systemVariables';
import { PayeeTypes, SourceTypes } from '../../../lib/constants';

export default class RecipientAccountApplications extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedApplicationId: null
        };
    }

    componentWillUnmount() {
        if (this.props.editMode) this.props.toggleEditMode();
    }

    getInitialFormattedApplication = (applicationDetails) => {
        return {
            paymentInfo: {
                manualPayment: {
                    blankCheckId: applicationDetails.paymentInfo.manualPayment ? applicationDetails.paymentInfo.manualPayment.blankCheckId || null : null,
                    manualPaymentType: applicationDetails.paymentInfo.manualPayment ? applicationDetails.paymentInfo.manualPayment.manualPaymentType || null : null,
                    manualPaymentNumber: applicationDetails.paymentInfo.manualPayment ? applicationDetails.paymentInfo.manualPayment.manualPaymentNumber || null : null,
                    manualPaymentDate: applicationDetails.paymentInfo.manualPayment ? applicationDetails.paymentInfo.manualPayment.manualPaymentDate || null : null,
                    manualPaymentAmount: applicationDetails.paymentInfo.manualPayment ? applicationDetails.paymentInfo.manualPayment.manualPaymentAmount || null : null,
                },
                fundId: applicationDetails.paymentInfo.fundId,
                payTo: applicationDetails.paymentInfo.payTo,
                thirdParty: {
                    referenceId: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.referenceId : '',
                    useRecipientAddress: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.useRecipientAddress : false,
                    isIsraeli: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.isIsraeli : this.props.recipientDetails.isIsraeli,
                    firstName: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.firstName || '' : '',
                    lastName: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.lastName || '' : '',
                    orgName: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.orgName || '' : '',
                    address: applicationDetails.paymentInfo.thirdParty && applicationDetails.paymentInfo.thirdParty.address ? applicationDetails.paymentInfo.thirdParty.address : {},
                    bankNumber: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.bankNumber || '' : '',
                    branchNumber: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.branchNumber || '' : '',
                    accountNumber: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.accountNumber || '' : '',
                    accountHolder: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.accountHolder || '' : '',
                    careOf: applicationDetails.paymentInfo.thirdParty ? applicationDetails.paymentInfo.thirdParty.careOf || '' : '',
                },
                checkMemo: applicationDetails.paymentInfo.checkMemo || '',
                reportMemo: applicationDetails.paymentInfo.reportMemo || '',
            },
            isPrivate: applicationDetails.isPrivate,
            reasonId: applicationDetails.reason ? applicationDetails.reason.applicationReasonId : '',
            amount: applicationDetails.amount || '',
            requestAmount: applicationDetails.requestedAmount || '',
            approverId: applicationDetails.approverId || '',
            sourceId: applicationDetails.source ? applicationDetails.source.referenceId : '',
            individualCategoryId: applicationDetails.campaignIndividualCategoryId || '',
            newAttachments: [],
            deletedAttachments: [],
            cardTypeId: applicationDetails.cardId || '',
            printInstructions: applicationDetails.printInstructions || '',
            inquire: applicationDetails.inquire,
            inquireNote: applicationDetails.inquireNote || '',
            applicantPledgeId: applicationDetails.applicantPledgeId || '',
            reasonDate: applicationDetails.reasonDate || '',
            weddingHall: applicationDetails.weddingHall || '',
            weddingSide: applicationDetails.weddingSide || '',
        };
    }

    getIncompleteFields = (applicationDetails, thirdPartyPayeeType) => {
        const application = applicationDetails || this.getInitialFormattedApplication(this.props.currentApplicationDetails.data);
        const recipient = this.props.recipientDetails;

        const initialApplicationDetails = this.props.currentApplicationDetails.data;

        let incompleteFields = { applicationInfo: [], paymentInfo: [] };
        const incompleteRecipientInfo = [];

        //if manual payment only require manual payment fields and last name
        if (application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType) {
            if (!application.paymentInfo.manualPayment.manualPaymentAmount || !application.paymentInfo.manualPayment.manualPaymentDate || !application.paymentInfo.manualPayment.manualPaymentNumber) {
                incompleteFields.paymentInfo.push('Incomplete Manual Payment Information');
            }

            if (recipient.applicantType === RecipientTypes.Individual) {
                if (!recipient.lastName) incompleteRecipientInfo.push('Last Name');
            } else {
                if (!recipient.organization.name) incompleteRecipientInfo.push('Name');
            }
        }
        else {
            //recipient info
            if (recipient.incomplete) {
                if (recipient.applicantType === RecipientTypes.Individual) {
                    if (!recipient.firstName) incompleteRecipientInfo.push('First Name');
                    if (!recipient.lastName) incompleteRecipientInfo.push('Last Name');
                } else {
                    if (!recipient.organization.name) incompleteRecipientInfo.push('Name');
                    if (recipient.organization.registered && !recipient.organization.taxId) incompleteRecipientInfo.push('Tax ID');
                }
                if (recipient.isIsraeli) {
                    if (recipient.applicantType === RecipientTypes.Individual && !recipient.teudatZahut) incompleteRecipientInfo.push('Teudat Zehut');

                    if (!recipient.trustedPayee) {
                        const activeBankAcct = recipient.bankAccounts.filter(acct => acct.active)[0];
                        if (!activeBankAcct) {
                            incompleteRecipientInfo.push('Active Bank Account');
                        } else {
                            if (!activeBankAcct.bankRoutingNumber) incompleteRecipientInfo.push('Active Bank Account - Bank Number');
                            if (!activeBankAcct.bankBranchNumber) incompleteRecipientInfo.push('Active Bank Account - Branch Number');
                            if (!activeBankAcct.bankAccountNumber) incompleteRecipientInfo.push('Active Bank Account - Account Number');
                        }
                    }
                }
                if (!recipient.tags.length) incompleteRecipientInfo.push('Categories');
                if (!recipient.address.streetNumber || !recipient.address.street || !recipient.address.city || !recipient.address.country) incompleteRecipientInfo.push('Address is Incomplete');
            }

            //applicationInfo:
            if (!initialApplicationDetails.campaign && !application.reasonId) incompleteFields.applicationInfo.push('Reason');
            if (!application.approverId) incompleteFields.applicationInfo.push('Approver');
            if (initialApplicationDetails.status === ApplicationStatuses.Approved && !application.amount) incompleteFields.applicationInfo.push('Amount');

            //paymentInfo:
            if (!application.paymentInfo.fundId) incompleteFields.paymentInfo.push('Fund');
            const thirdParty = application.paymentInfo.thirdParty;
            if (application.paymentInfo.payTo === PayeeTypes.ThirdParty) {
                if (thirdPartyPayeeType === SourceTypes.Reference) {
                    if (!thirdParty.referenceId)
                        incompleteFields.paymentInfo.push('Third Party Payee');
                } else {
                    if (!thirdParty.orgName && (!thirdParty.firstName || !thirdParty.lastName)) incompleteFields.paymentInfo.push('Third Party Payee Name');
                    if (thirdParty.isIsraeli && (!application.paymentInfo.manualPayment || !application.paymentInfo.manualPayment.manualPaymentType)
                        && (!thirdParty.bankNumber || !thirdParty.branchNumber || !thirdParty.accountNumber))
                        incompleteFields.paymentInfo.push('Third Party Payee Bank Information');
                    else if (!thirdParty.isIsraeli && (!application.paymentInfo.manualPayment || !application.paymentInfo.manualPayment.manualPaymentType) && !thirdParty.useRecipientAddress
                        && (!thirdParty.address.streetNumber || !thirdParty.address.street || !thirdParty.address.city || !thirdParty.address.country))
                        incompleteFields.paymentInfo.push('Third Party Payee Address');
                }
            }
        }
        if (!incompleteFields.applicationInfo.length && !incompleteFields.paymentInfo.length && incompleteRecipientInfo.length) { //only recipient is incomplete
            const missingOnlyRecipientPaymentInfo = incompleteRecipientInfo.every(field => field.indexOf('Active Bank Account') >= 0); //missing only pymt info
            const notUsingRecipientPaymentInfo = (application.paymentInfo.payTo !== PayeeTypes.Recipient || (application.paymentInfo.manualPayment && application.paymentInfo.manualPayment.manualPaymentType)); //AND not pay to recipient, or manual check pymt (so don't need recipient pymt info)

            incompleteFields.incompleteApplicationDueToRecipient = !missingOnlyRecipientPaymentInfo || !notUsingRecipientPaymentInfo;
            incompleteFields.recipientInfo = incompleteRecipientInfo; //add incomplete recipient info only if affecting application
        }

        return (incompleteFields.applicationInfo.length || incompleteFields.paymentInfo.length || incompleteFields.incompleteApplicationDueToRecipient) ? incompleteFields : null;
    }

    render() {
        const applications = this.props.applicationHistory.data;
        const selectedApplicationIndex = applications.map(app => app.applicationId).indexOf(this.props.currentApplicationId);

        return (
            <div className="application-details flex">
                <ApplicationsHistoryTable
                    currentApplicationId={this.props.currentApplicationId}
                    applications={applications}
                    export={this.props.export}
                    editMode={this.props.editMode}
                    loading={this.props.applicationHistory.loading}
                    recipientId={this.props.recipientDetails.applicantId}
                    recipientName={this.props.recipientDetails.applicantType === RecipientTypes.Organization ? this.props.recipientDetails.organization.name : `${this.props.recipientDetails.lastName} ${this.props.recipientDetails.firstName}`}
                    totalPaid={this.props.recipientDetails.totalPaid}
                    recipientIsIsraeli={this.props.recipientDetails.isIsraeli}
                    selectApplication={this.props.selectApplication.bind(this)}
                    allowCreate={this.props.permissions.applications.manage} 
                    getRecipientApplicationsForExport={this.props.getRecipientApplicationsForExport}/>

                <div className="details-card-container">
                    {this.props.currentApplicationId && <div>
                        {this.props.editMode
                            ? <ApplicationDetailsEditCard
                                recipientDetails={this.props.recipientDetails}
                                applicationDetails={this.props.currentApplicationDetails.data}

                                updateApplication={this.props.updateApplication}
                                updateApplicationDetails={this.props.updateApplicationDetails}
                                getApplicationDetails={this.props.getApplicationDetails}
                                getApplicationHistory={this.props.getApplicationHistory}
                                permissions={this.props.permissions}
                                toggleEditMode={this.props.toggleEditMode}

                                getBlankChecks={this.props.getBlankChecks}
                                blankChecks={this.props.blankChecks}
                                manualPaymentTypes={this.props.manualPaymentTypes}
                                tags={this.props.tags}
                                userId={this.props.userId}

                                getInitialFormattedApplication={this.getInitialFormattedApplication}
                                getIncompleteFields={this.getIncompleteFields} />
                            : <ApplicationDetailsCard
                                recipientDetails={this.props.recipientDetails}
                                applicationDetails={this.props.currentApplicationDetails.data}
                                loading={this.props.currentApplicationDetails.loading}

                                totalApplications={applications.length}
                                applicationIndex={selectedApplicationIndex + 1}
                                prevApplicationId={(selectedApplicationIndex <= 0) ? null : applications[selectedApplicationIndex - 1].applicationId}
                                nextApplicationId={(selectedApplicationIndex < 0 || selectedApplicationIndex === applications.length - 1) ? null : applications[selectedApplicationIndex + 1].applicationId}
                                selectApplication={this.props.selectApplication.bind(this)}

                                toggleEditMode={this.props.toggleEditMode}
                                disableEditMode={this.props.disableEditMode}

                                updateApplicationStatus={this.props.updateApplicationStatus}
                                revertApplicationStatus={this.props.revertApplicationStatus}
                                applicationStatusUpdate={this.props.applicationStatusUpdate}
                                getApplicationDetails={this.props.getApplicationDetails}

                                printCheck={this.props.printCheck}
                                printing={this.props.printing}
                                confirmPrinting={this.props.confirmPrinting}
                                confirmingPrinting={this.props.confirmingPrinting}
                                wireApplication={this.props.wireApplication}
                                sendACH={this.props.sendACH}
                                sendingACH={this.props.sendingACH}
                                voidPayment={this.props.voidPayment}
                                voidingPayment={this.props.voidingPayment}
                                addNote={this.props.addNote}
                                updateNote={this.props.updateNote}
                                deleteNote={this.props.deleteNote}
                                updatingNote={this.props.updatingNote}
                                updateAttachments={this.props.updateAttachments}
                                updatingAttachments={this.props.updatingAttachments}
                                updateReceipts={this.props.updateReceipts}
                                deleteReceipt={this.props.deleteReceipt}
                                updatingReceipts={this.props.updatingReceipts}

                                userId={this.props.userId}
                                permissions={this.props.permissions.applications}
                                admin={this.props.permissions.admin}
                                funds={this.props.funds}

                                getIncompleteFields={this.getIncompleteFields} />}
                    </div>}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientAccountApplications.jsx